export default "__VITE_ASSET__B$Axve1g__"